<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="() => $router.push({ name: 'matriculas' })"
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Matricula
        </h1>
      </v-col>
    </v-row>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitForm)" :disabled="submittingForm">
        <v-row v-for="matricula of form.matriculas" :key="form.matriculas.indexOf(matricula)">
          <v-col class="pt-0 pb-0" cols="4">
            <e-label>Aluno</e-label>
            <e-autocomplete
              :items="alunosDisponiveis(matricula)"
              :return-object="false"
              :item-value="(aluno) => aluno.id"
              :item-text="(aluno) => aluno.nomecompleto"
              :loading="carregandoAlunos"
              :readonly="editing"
              v-model="matricula.aluno_id"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>

          <v-col class="pt-0 pb-0" cols="4">
            <e-label>Turma</e-label>
            <e-autocomplete
              :items="turmasList"
              :return-object="true"
              :item-text="(turma) => turma.descricao"
              v-model="matricula.turma"
              @change="(serie) => changeTurma(matricula, matricula.turma, serie)"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="3">
            <e-label>Ano</e-label>
            <e-autocomplete
              :items="matricula.turma ? matricula.turma.series : []"
              :return-object="false"
              :item-value="(serie) => serie.id"
              :item-text="(serie) => serie.descricao"
              :disabled="!matricula.turma"
              @change="(serie) => changeTurma(matricula, matricula.turma, serie)"
              v-model="matricula.serie_id"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>
          <v-col
            class="pl-4 pr-4 pt-0 pb-10"
            cols="4"
            v-show="matriculasAnterioresList.some((m) => m.aluno_id === matricula.aluno_id)"
          >
            <!-- v-show="showSwitchMatriculasAnteriores" -->
            <v-switch
              v-model="matricula.importarNotasFaltas"
              label="Importar Notas e Faltas?"
              inset
              hide-details
              class="mt-6"
            />
          </v-col>
          <v-col cols="12">
            <e-modal-matriculas-disponiveis
              v-if="verificaAlunoMatriculasAnteriores(matricula, matriculasAnterioresList)"
              :matriculas="
                matriculasAnterioresList.filter((m) => m.aluno_id === matricula.aluno_id)
              "
              v-model="matricula.matriculaASerImportadaId"
            />
          </v-col>

          <v-col class="pt-0 pb-0" cols="1">
            <v-btn
              v-if="form.matriculas.length > 1"
              class="mt-8"
              color="error"
              @click="
                () =>
                  (form.matriculas = form.matriculas.filter(
                    (matriculaObj) => matriculaObj !== matricula
                  ))
              "
              small
              ><v-icon small>fa-trash</v-icon></v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <div class="d-flex">
              <v-btn
                color="primary"
                :disabled="submittingForm"
                :loading="submittingForm"
                type="submit"
                >Enviar Dados</v-btn
              >
              <v-btn class="ml-3" v-if="!editing" color="secondary" @click="adicionarMatricula">
                Adicionar
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </form>
    </ValidationObserver>
    <e-modal-matriculas-anteriores
      v-model="showModalMatriculasAnteriores"
      :matriculasAnterioresList="
        matriculasAnterioresList.filter((m) => m.aluno_id === matriculaAtual.aluno_id)
      "
    ></e-modal-matriculas-anteriores>
  </main-template>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ELabel from "../../components/ELabel.vue";
import EModalMatriculasAnteriores from "../../components/Matriculas/EModalMatriculasAnteriores.vue";
import EModalMatriculasDisponiveis from "../../components/Matriculas/EModalMatriculasDisponiveis.vue";

export default {
  components: { ELabel, EModalMatriculasAnteriores, EModalMatriculasDisponiveis },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // ...mapGetters("Matriculas", ["matriculas", "carregandoMatriculas"]),
    // ...mapGetters("Alunos", ["alunosList", "carregandoAlunos"]),
    // ...mapGetters("Turmas", ["turmasList", "carregandoTurmas"]),

    selectedAlunoIds() {
      return new Set((this.form.matriculas || []).map((m) => m.aluno_id).filter(Boolean));
    },
  },
  mounted() {
    this.loadData();
    // this.loadFormData();
  },
  data() {
    return {
      turmasList: [],
      submittingForm: false,
      form: { matriculas: [{}] },
      series: [],
      alunosList: [],
      carregandoAlunos: false,
      showModalMatriculasAnteriores: false,
      // showSwitchMatriculasAnteriores: false,
      matriculasAnterioresList: [],
      importarNotasFaltas: false,
      matriculaAtual: null,
    };
  },
  methods: {
    // ...mapActions("Alunos", ["loadAlunos"]),
    // ...mapActions("Turmas", ["loadTurmas"]),
    async changeTurma(matricula, turma, serie_id) {
      matricula.turma_id = turma.id;
      matricula.serie_id = serie_id;

      this.matriculaAtual = matricula;

      if (matricula.turma.series.length === 1) {
        matricula.serie_id = matricula.turma.series[0].id;
      }

      this.$set(matricula, "importarNotasFaltas", false);
      this.$set(matricula, "matriculaASerImportadaId", null);

      this.showSwitchMatriculasAnteriores = false;
      this.showModalMatriculasAnteriores = false;

      this.matriculasAnterioresList = this.matriculasAnterioresList.filter(
        (m) => m.aluno_id !== matricula.aluno_id
      );

      await this.loadMatriculasAnteriores(matricula.aluno_id, matricula.serie_id);

      if (this.verificaAlunoMatriculasAnteriores(matricula, this.matriculasAnterioresList)) {
        this.showModalMatriculasAnteriores = true;
      }
    },

    verificaAlunoMatriculasAnteriores(matricula, matriculasAnterioresList) {
      return (
        matricula.importarNotasFaltas &&
        matriculasAnterioresList.some((m) => m.aluno_id === matricula.aluno_id)
      );
    },
    adicionarMatricula() {
      this.form.matriculas.push({});
    },
    async submitForm() {
      this.form.especial = Boolean(this.form.especial);
      this.form.recursos_saeb = this.recursos_saeb;
      this.submittingForm = true;

      const matriculasSemSelecao = this.form.matriculas.some(
        (m) => m.importarNotasFaltas && !m.matriculaASerImportadaId
      );

      if (matriculasSemSelecao) {
        this.$toast.danger(
          "Por favor, selecione qual matrícula deseja importar as notas e faltas."
        );
        this.submittingForm = false;
        return;
      }

      try {
        if (this.editing) {
          await this.$services.matriculasService.atualizarMatricula(this.form.matriculas[0]);
        } else {
          await this.$services.matriculasService.matricular(this.form);
        }
        this.$toast.success("Matricula Atualizada com sucesso");
        this.$router.push({ name: "matriculas" });
      } catch (error) {
        this.$handleError(error);
      }
      this.submittingForm = false;
    },

    async loadMatriculasAnteriores(aluno_id, serie_id) {
      try {
        const novasMatriculas = await this.$services.matriculasService.verificaMatriculasInativas(
          aluno_id,
          serie_id
        );

        const idsExistentes = new Set(this.matriculasAnterioresList.map((m) => m.id));

        const matriculasNovas = novasMatriculas.filter(
          (m) => !idsExistentes.has(m.id) && m.aluno_id === aluno_id
        );

        this.matriculasAnterioresList.push(...matriculasNovas);

        if (novasMatriculas.length > 0) {
          this.showModalMatriculasAnteriores = true;
        }
      } catch (error) {
        console.error("erro ao carregar matrículas anteriores:", error);
        this.$handleError(error);
      }
    },
    async loadAlunos() {
      this.carregandoAlunos = true;
      try {
        this.alunosList = await this.$services.alunosService.syncAll();
      } catch (error) {
        this.$handleError(error);
      }
      this.carregandoAlunos = false;
    },

    alunosDisponiveis(matriculaAtual) {
      const { alunosList } = this;
      const AlunosSelecionados = this.selectedAlunoIds;

      return alunosList.filter(
        (aluno) => !AlunosSelecionados.has(aluno.id) || aluno.id === matriculaAtual.aluno_id
      );
    },

    filtraAlunosSelecionados() {
      return this.alunosList.filter((aluno) => {
        return this.form.matriculas.some((matricula) => matricula.aluno_id === aluno.id);
      });
    },
    async loadMatriculas() {
      try {
        this.matriculas = await this.$services.matriculasService.syncAll();
      } catch (error) {
        this.$handleError(error);
      }
    },
    async loadTurmas() {
      try {
        this.turmasList = await this.$services.turmasService.syncAll();
      } catch (error) {
        this.$handleError(error);
      }
    },
    async loadData() {
      try {
        if (this.alunosList.length === 0 || this.turmasList.length === 0) {
          this.$loaderService.open("Carregando dados");
        }
        await this.loadFormData();

        await Promise.all([this.loadTurmas(), this.loadMatriculas()]);
        this.$loaderService.close();
        this.$forceUpdate();
        this.loadAlunos();

        this.loadFormData();
      } catch (error) {
        this.$handleError(error);
      }
    },
    async loadFormData() {
      if (!this.matriculas || !this.editing) {
        this.form = { matriculas: [{}] };
        return;
      }
      const { matricula_id } = this.$route.params;
      const matricula = await this.$services.matriculasService.getMatricula(matricula_id);

      if (matricula) this.form = { matriculas: [matricula] };
    },
  },
};
</script>

<style></style>
